import { render, staticRenderFns } from "./TransporterEdit.vue?vue&type=template&id=0e132247"
import script from "./TransporterEdit.vue?vue&type=script&lang=js"
export * from "./TransporterEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports